var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-toolbar ofh"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"fl"},[_vm._t("handler")],2),_c('div',{staticClass:"fr"},[_vm._t("page")],2)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }